import { render, staticRenderFns } from "./RegistroComponent.vue?vue&type=template&id=f73c667a&scoped=true&"
import script from "./RegistroComponent.vue?vue&type=script&lang=js&"
export * from "./RegistroComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73c667a",
  null
  
)

export default component.exports